import { studyProgrammeConstants } from './apiConstants';

export const GRADE_1 = studyProgrammeConstants.firstGradeHref;
export const GRADE_2 = studyProgrammeConstants.secondGradeHref;
export const GRADE_3 = studyProgrammeConstants.thirdGradeHref;
export const grade2StartDate = new Date(2021, 8, 1); // 1st September 2021
// export const grade3StartDate = new Date(2023, 8, 1); // 1st September 2023;
